import { Container, Stack, type StackProps } from "@octopus-energy/coral/atoms"

export function DashboardLayoutSection(props: StackProps) {
    return (
        <Container paddingX={{ base: "sm", md: "none" }}>
            <Stack
                flexDirection="column"
                gap="lg"
                {...props}
            />
        </Container>
    )
}
